import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Stack, Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import { QuoteModal } from "../QuoteModal";
import "./NavBar.css";

const NavBar = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="navBar">
      {/* Navigation Links */}
      <div id="navItems">
        <Link id="homeHeader" className="active" to="/">Home</Link>
        <Link to="/services">Services</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/contact">Contact</Link>
      </div>

      {/* Contact Modal Button */}
      <div id="quoteDiv">
        <Stack spacing={2} direction="row">
          <Button
            onClick={handleOpen}
            id="buttonQuote"
            size="large"
            variant="contained"
          >
            {/* CONTACT US */}
          </Button>
        </Stack>
      </div>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <QuoteModal />
      </Modal>
    </div>
  );
};

export default NavBar;
